import storeInfo from '../store'
import { SubscriptionType } from './types'

export const getSubscription = () => (): SubscriptionType => {
  const { subscription } = storeInfo.store.getState()
  return subscription
}
